import React from 'react';
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from "react-router";

import './index.css'
import App from './App'
import GalleryPage from './pages/krishnaGallery';
import RadhaMadhavKitchen from './pages/radhaMadhavKitchen';
import KrishnaEvents from './pages/KrishnaEvents';
import KrishnaTemple from './pages/KrishnaTemple';
import KrishnaTempleDonate from './pages/KrishnaTempleDonate';
import Templecontact from './pages/KrishnaContact';

const root = document.getElementById("root");
 
ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/krishna-temple-events" element={<KrishnaEvents />} />
      <Route path="/krishna-temple-gallery" element={<GalleryPage />} />
      <Route path="/about-krishna-temple" element={<KrishnaTemple />} />
      <Route path="/donate" element={<KrishnaTempleDonate />} />
      <Route path="/radha-madhav-kitchen" element={<RadhaMadhavKitchen />} />
      <Route path="/krishna-temple-about" element={<App />} />
      <Route path="/krishna-temple-contact" element={<Templecontact />} />
    </Routes>
  </BrowserRouter>
)
